import React from 'react';
import ProductCategoryAssignmentList from '../components/products/ProductCategoryAssignmentList';
import { useLanguage } from '../contexts/LanguageContext';
import CommonPageHeader from '../components/common/CommonPageHeader';
import { TagIcon } from '@heroicons/react/24/outline';

const ProductCategoryAssignment = () => {
  const { t } = useLanguage();

  return (
    <div className="space-y-4 pb-20 sm:pb-6">
      <CommonPageHeader
        title="Termékek kategorizálása"
        subtitle="Termékek hozzárendelése webshop kategóriákhoz - tömegesen is"
        icon={TagIcon}
      />
      <ProductCategoryAssignmentList />
    </div>
  );
};

export default ProductCategoryAssignment;
